import React from "react";
import Chart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

export default function ApexTopMedicinesChart({ data }) {
    const theme = useTheme();

    const chartData = React.useMemo(() => (Array.isArray(data) && data.length > 0
        ? data.map(item => ({
            x: item.name || "Unknown",
            y: parseInt(item.quantity || 0)
        })).slice(0, 5)
        : [
            { x: "Paracetamol", y: 450 },
            { x: "Amoxicillin", y: 380 },
            { x: "Vitamin C", y: 320 },
            { x: "Ibuprofen", y: 280 },
            { x: "Omeprazole", y: 240 }
        ]), [data]);

    const options = React.useMemo(() => ({
        chart: {
            id: "dashboard-top-medicines",
            type: "bar",
            toolbar: { show: false },
            fontFamily: "inherit"
        },
        plotOptions: {
            bar: {
                borderRadius: 8,
                horizontal: true,
                barHeight: "60%",
                distributed: true,
                dataLabels: { position: "right" }
            }
        },
        colors: [
            theme.palette.primary.main,
            theme.palette.secondary.main,
            theme.palette.success.main,
            theme.palette.warning.main,
            theme.palette.info.main
        ],
        dataLabels: {
            enabled: true,
            textAnchor: "start",
            style: {
                colors: ["#fff"],
                fontSize: "12px",
                fontWeight: 600
            },
            formatter: (val) => `${val} units`,
            offsetX: 0
        },
        xaxis: {
            categories: chartData.map(item => item.x),
            labels: { show: false },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            labels: {
                style: {
                    colors: theme.palette.text.secondary,
                    fontSize: "13px",
                    fontWeight: 500
                }
            }
        },
        grid: {
            show: false
        },
        legend: { show: false },
        tooltip: {
            theme: theme.palette.mode,
            y: {
                title: { formatter: () => "Quantity: " }
            }
        }
    }), [theme.palette.primary.main, theme.palette.secondary.main, theme.palette.success.main, theme.palette.warning.main, theme.palette.info.main, theme.palette.text.secondary, theme.palette.mode, chartData]);

    const series = React.useMemo(() => [{
        name: "Quantity Sold",
        data: chartData.map(item => item.y)
    }], [chartData]);

    return (
        <div className="apex-chart-wrapper" style={{ width: '100%', height: '100%' }}>
            <Chart options={options} series={series} type="bar" height="100%" />
        </div>
    );
}
